/* eslint-disable no-param-reassign */
import React from 'react';

export const EditWorkerCell = (props: any) => {
  const { data, rgHash } = props;
  const { roleGroupId } = data;
  const roleGroup =
    roleGroupId != null ? rgHash?.[roleGroupId.toString()] : null;

  const assignedRoles = Object.values(roleGroup?.pimAssignments || {});

  // HTML divs of care providers to be displayed in grid.
  const assignedProviders: any = assignedRoles.map((assignment: any) => {
    const { firstname, lastname, credentials } = assignment;
    return (
      <div
        key={`${firstname} ${lastname}`}
        style={{ width: '140px', textOverflow: 'ellipsis', overflow: 'hidden' }}
      >
        {`${firstname} ${lastname}`}
        {credentials && `, ${credentials}`}
      </div>
    );
  });

  return <div>{assignedProviders}</div>;
};

export default EditWorkerCell;
